import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Users, ArrowRight, Building2, Briefcase, Calculator, FileSearch, Wrench, Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

export default function EspaceProPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-navy flex flex-col">
      {/* Header */}
      <header className="py-6 px-6 border-b border-white/10">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate('/')}
              className="text-white/70 hover:text-white hover:bg-white/10"
              data-testid="back-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour
            </Button>
            <h1 
              className="font-heading text-xl font-bold text-white cursor-pointer"
              onClick={() => navigate('/')}
            >
              L'ŒIL DU MARCHAND
            </h1>
          </div>
          <span className="text-gold font-medium">ESPACE PRO</span>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-4xl">
          {/* Title */}
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
              Bienvenue dans l'Espace Pro
            </h2>
            <p className="text-white/70 text-lg">
              Choisissez votre accès
            </p>
          </div>

          {/* Two Cards */}
          <div className="grid md:grid-cols-2 gap-8">
            {/* Mon Admin */}
            <Card 
              className="border-0 shadow-2xl bg-white/5 backdrop-blur hover:bg-white/10 transition-all cursor-pointer group"
              onClick={() => navigate('/admin/login')}
              data-testid="mon-admin-card"
            >
              <CardContent className="p-8">
                <div className="flex flex-col items-center text-center">
                  <div className="w-20 h-20 rounded-full bg-gold/20 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                    <Shield className="w-10 h-10 text-gold" />
                  </div>
                  <h3 className="font-heading text-2xl font-bold text-white mb-3">
                    Mon Admin
                  </h3>
                  <p className="text-white/70 mb-6">
                    Accédez à votre tableau de bord administrateur pour gérer vos audits, clients et collaborateurs.
                  </p>
                  <Button 
                    className="bg-gold hover:bg-gold/90 text-black font-semibold w-full"
                    data-testid="admin-login-btn"
                  >
                    Connexion Admin
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </div>
              </CardContent>
            </Card>

            {/* Mon Réseau */}
            <Card 
              className="border-0 shadow-2xl bg-white/5 backdrop-blur hover:bg-white/10 transition-all cursor-pointer group"
              onClick={() => navigate('/reseau')}
              data-testid="mon-reseau-card"
            >
              <CardContent className="p-8">
                <div className="flex flex-col items-center text-center">
                  <div className="w-20 h-20 rounded-full bg-emerald-500/20 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                    <Users className="w-10 h-10 text-emerald-400" />
                  </div>
                  <h3 className="font-heading text-2xl font-bold text-white mb-3">
                    Mon Réseau
                  </h3>
                  <p className="text-white/70 mb-6">
                    Rejoignez notre réseau de professionnels : partenaires, affiliés, artisans, analystes...
                  </p>
                  <Button 
                    className="bg-emerald-500 hover:bg-emerald-600 text-white font-semibold w-full"
                    data-testid="reseau-btn"
                  >
                    Rejoindre le Réseau
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Quick Access Icons */}
          <div className="mt-12 pt-8 border-t border-white/10">
            <p className="text-white/50 text-center text-sm mb-6">Accès rapide collaborateurs</p>
            <div className="flex justify-center gap-6 flex-wrap">
              <button 
                onClick={() => navigate('/analyst')}
                className="flex flex-col items-center gap-2 text-white/50 hover:text-white transition-colors"
                data-testid="quick-analyst"
              >
                <FileSearch className="w-6 h-6" />
                <span className="text-xs">Analyste</span>
              </button>
              <button 
                onClick={() => navigate('/chiffreur')}
                className="flex flex-col items-center gap-2 text-white/50 hover:text-white transition-colors"
                data-testid="quick-chiffreur"
              >
                <Calculator className="w-6 h-6" />
                <span className="text-xs">Chiffreur</span>
              </button>
              <button 
                onClick={() => navigate('/reseau/artisan/login')}
                className="flex flex-col items-center gap-2 text-white/50 hover:text-white transition-colors"
                data-testid="quick-artisan"
              >
                <Wrench className="w-6 h-6" />
                <span className="text-xs">Artisan</span>
              </button>
              <button 
                onClick={() => navigate('/reseau/affiliate/login')}
                className="flex flex-col items-center gap-2 text-white/50 hover:text-white transition-colors"
                data-testid="quick-affiliate"
              >
                <Briefcase className="w-6 h-6" />
                <span className="text-xs">Affilié</span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-4 px-6 border-t border-white/10">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-white/40 text-sm">
            L'Œil du Marchand - Expertise Immobilière Certifiée
          </p>
        </div>
      </footer>
    </div>
  );
}
